import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';

import { REGISTERS, type PostType } from '@/features/posts/registers';

interface TypeBadgeProps {
  type: PostType;
  size?: 'small' | 'medium';
}

/**
 * The register pill: colour **and** icon **and** text label, always all three.
 *
 * Spec §9.2 forbids signalling a register by colour alone, so this component
 * deliberately offers no icon-only or label-only variant — there is no way to
 * use it that drops one of the three channels.
 */
export function TypeBadge({ type, size = 'medium' }: TypeBadgeProps) {
  const { t } = useTranslation();
  const register = REGISTERS[type];

  return (
    <Chip
      size={size}
      color={register.accent}
      variant="filled"
      icon={<register.Icon fontSize="small" aria-hidden />}
      label={t(`registers.${type}.label`)}
    />
  );
}
